import React, {useState} from 'react'
import {Card, Typography} from '@mui/material'
import {Finalizar,NumeroTarjeta,TiposTarjeta,Carrera,Instrumento,Opciones,Programa,Modalidad,Horario,Cuatrimestre,Ubicacion,Telefonos,GenericCard} from './index'
import {useHelper} from '../hooks/useHelper'
import {useCards} from '../hooks/useCards'
import {Dialogos} from '../componentes/Dialogos'
import Alert from '@mui/material/Alert';
import { useTimePickerDefaultizedProps } from '@mui/x-date-pickers/TimePicker/shared';
import {preguntas} from '../preguntas.json';
import { ArrowDownIcon } from '@heroicons/react/16/solid';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import DOMPurify from 'dompurify';

export const LayoutCards = ()=>{
    const { datos,
            tipoParticipante,
            cargando} = useCards()
    const [datosConfirmados,setDatosConfirmados] = useState(false)

    if (cargando) {
        return <p>Cargando...</p>
    }

    return <Card style={{display:'flex',maxWidth:'800px',marginLeft:'auto',marginRight:'auto', flexDirection:'column', padding:'1px', justifyContent:'center',background:'#E7EBF0'}}> 
        <div>
            <img src={process.env.REACT_APP_IMAGEN_EVENTO} alt="Convención" style={{width:'100%'}} />
            
            <GenericCard titulo={process.env.REACT_APP_TITULO_EVENTO} id='tl-ubicacion' 
                        mostrar={true} 
                        error={false}
                        subtitulo={tipoParticipante=='general' ? 'Para inscribirse a éste evento por favor siga las instrucciones' : 'Inscripción de contingentes y otros'}
                        mensajeError = {'nada'}
                        >
                            <Opciones/>
             </GenericCard>
       

            <Dialogos open={datosConfirmados} 
                    titulo='Para continuar por favor ingresá los datos de tu tarjeta y aceptá los términos y condiciones' 
                    subtitulo='Subtítulo' 
                    procesarCancelar = {()=>alert(1)}
                    error={false}>
                            <h1>algo</h1>
            </Dialogos>
            <PreguntasFrecuentes/>
        </div>
     </Card>
}


const PreguntasFrecuentes = ()=>{

    return  <Card style={{padding:'16px'}}> 
         <Typography style={{padding:'20px'}} variant='h6' align='left' color='primary'>
          Preguntas frecuentes
      </Typography>
        {preguntas.map((item,index)=>{
            return  <SeccionPregunta
            pregunta={item.pregunta}
            respuesta={item.respuesta}
            id= {`pregunta-${index}`}
        />
        })}
</Card>
}

const SeccionPregunta = ({pregunta, respuesta,id})=>{

    return  <Accordion>
    <AccordionSummary sx={{padding:'50px'}}
      expandIcon={<ArrowDownIcon />}
      aria-controls={id}
      id={id}
    >
      <Typography variant='h6'>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pregunta) }} />
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography align='left'  variant='subtitle1'>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(respuesta) }} />
      </Typography>
    </AccordionDetails>
  </Accordion>
}
